export enum PAGE_PATHS {
  SUBSCRIPTIONS = '/subscriptions',
  SUBSCRIPTIONS_RESULT = '/subscriptions/result',
  SUBSCRIBERS = '/subscribers',
  SUBSCRIBERS_LOGIN = '/subscribers/auth',
  SUBSCRIBERS_MODIFY = '/subscribers/modify',
  SUBSCRIBERS_PAYMENT_HISTORY = '/subscribers/payment/history',
  ARCHIVES = '/archives',
}